import './bootstrap.js';
import '../../css/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import Clarity from '@microsoft/clarity';
import GTMEventManager from '@/app/GTMEventManager.js';
import numbro from 'numbro';
import ErrorBoundary from '@/app/ErrorBoundary.jsx';

import { journeyUrl } from './bookingJourney.js';

const appName = import.meta.env.VITE_APP_NAME || 'The Gate VR';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx')),
    setup({ el, App, props }) {
        let journeyPage = props.initialPage;
        router.on('navigate', event => { journeyPage = event.detail.page; });
        router.on('success', event => { journeyPage = event.detail.page; });
        router.on('before', event => {
            const visit = event.detail.visit;
            visit.url.search = journeyUrl(visit.url, window.location.href).search;
            if (visit.url.origin === window.location.origin && journeyPage.props.cart_context) {
                visit.headers['X-Booking-Cart'] = journeyPage.props.cart_context;
            }
        });
        const lang = props.initialPage.props.language ?? 'en';
        GTMEventManager.enable(props.initialPage.props?.settings?.gtm_enabled ?? false);

        Clarity.identify(props.initialPage.props.auth.uniq_id, props.initialPage.props.auth.session_id);
        console.log(`[Clarity] session: ${props.initialPage.props.auth.uniq_id} / ${props.initialPage.props.auth.session_id} - app`);

        window.__localeId__ = lang;
        numbro.setLanguage(lang);

        // In production, wrap the app in ErrorBoundary so React crashes redirect to /error
        // instead of showing a blank screen. In development we do not wrap so React's error
        // overlay and stack trace remain visible for debugging.
        const isProduction = import.meta.env.PROD;
        const AppWithBoundary = isProduction ? (
            <ErrorBoundary>
                <App {...props} />
            </ErrorBoundary>
        ) : (
            <App {...props} />
        );

        const root = createRoot(el);
        root.render(<StrictMode>{AppWithBoundary}</StrictMode>);
    },
    progress: {
        color: '#6bfed6',
    },
});
